import { render, staticRenderFns } from "./AffiliateAdministration.vue?vue&type=template&id=647fcfb6&"
import script from "./AffiliateAdministration.vue?vue&type=script&lang=ts&setup=true&"
export * from "./AffiliateAdministration.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./AffiliateAdministration.vue?vue&type=style&index=0&id=647fcfb6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports